import { TypographyVariant, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const useHeaderStyles = () => {
  const { palette, breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.up('sm'))
  const isMediumScreen = useMediaQuery(breakpoints.up('md'))
  const isLargeScreen = useMediaQuery(breakpoints.up('lg'))

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      variant: (isMediumScreen ? 'h3' : 'h4') as TypographyVariant,
      wrapper: {
        width: '14ch',
        color: palette.common.black,
        '& > span': {
          color: palette.primary.main,
        },
        marginBottom: '32px',
        maxWidth: isMediumScreen ? '457px' : '343px',
      },
    },
    stepperWrapper: {
      maxWidth: '100%',
      paddingLeft: isMediumScreen ? '35px' : '',
      paddingRight: isLargeScreen
        ? '35%'
        : isMediumScreen
        ? '20%'
        : isSmallScreen
        ? '0'
        : '',
      marginBottom: isMediumScreen ? '' : '78px',
      marginTop: isMediumScreen ? '' : '28px',
    },
    imageWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px',
      margin: isMediumScreen ? '16px 0' : '16px 0 32px',
      '& img': {
        border: `4px solid ${palette.primary.main} !important`,
        borderRadius: 100,
        zIndex: 2,
      },
      [breakpoints.up('md')]: {
        margin: '0 0 40px 0',
      },
    },
    image: isSmallScreen
      ? {
          width: '120px',
          height: '120px',
        }
      : {
          width: '104px',
          height: '104px',
        },
  }
}

export default useHeaderStyles
